import React from 'react';
import { useNavigate } from 'react-router';

import { StepProps } from '@/widgets/ServiceFormTemplate';

import { InvoiceStatus } from '@/shared/types';
import { StepControlPanel } from '@/shared/ui';

import { Result } from '@/components/Forms/Steps/Result';

import { ROUTES } from '@/router/config';

export interface StorageForCollectionResultProps {
  invoiceStatus: InvoiceStatus;
}

export const StorageForCollectionResultStep: React.FC<StepProps<StorageForCollectionResultProps>> = ({
  serviceCode,
  invoiceStatus,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Result variant="new" serviceCode={serviceCode} invoiceStatus={invoiceStatus} />

      <StepControlPanel
        next={() => navigate(ROUTES.USER.REQUESTS.ACTIVE_REQUESTS)}
        nextBtnText="Мої запити"
        withArrow={false}
      />
    </>
  );
};
